export class UsuarioLoginEntity {
    constructor(
        public Usuario?: string,
        public Clave?: string,
        public Tipo?: number) { }
}

export class UsuarioRespuestaEntity {
    constructor(
        public Usuario?: string,
        public Pregunta?: string,
        public Respuesta?: string,
        public Contrasena?: string,
        public OtraContrasena?: string,
        public CodigoUsuario?: number,
        public TipoUsuario?: number,
        public Error?: number,
        public Mensaje?: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/usuario_login_entity.ts